export function addTimeline(el) {

  if(!el) {
    return
  }

  var mouseDown = 'mousedown';
  var mouseMove = 'mousemove';
  var mouseUp = 'mouseup';
  if ( 'ontouchstart' in document.documentElement ) {
      mouseDown = 'touchstart';
      mouseMove = 'touchmove';
      mouseUp = 'touchend';
  }

  const timelineContainer = el
  const timelineItems = Array.from(el.querySelectorAll('.timeline-item'))
  const timelineWrap = el.querySelector('.timeline-content')

  const imgInfo = timelineWrap.style.backgroundImage.slice(4, -1).replace(/"/g, "")
  const img = new Image();
  img.onload = function(){
      const timelineWidth = this.width / 2
      timelineWrap.style.marginLeft = 0
      timelineWrap.style.width = `${timelineWidth}px`

      var scrubber = document.querySelector('.timeline-slider')
      var movement = (timelineWidth - timelineContainer.offsetWidth - 30) / 100
      scrubber.oninput = function() {
          timelineWrap.style.marginLeft = `-${this.value * movement}px`
      }
      scrubber.onchange = function() {
          timelineWrap.style.marginLeft = `-${this.value * movement}px`
      }
  };

  img.src = imgInfo;

}




// WEBPACK FOOTER //
// ./src/timeline.js